<template>
  <div>
    <h2>ユーザー管理</h2>

    <v-layout row　align-center>
      <v-flex md3>
        <v-btn @click="addItem">
          <v-icon>add</v-icon>追加
        </v-btn>
      </v-flex>
    </v-layout>
    <v-alert
      style="white-space: pre;"
      :value="true"
      v-for="(error, i) in errorMessages"
      :key="i"
    >{{error}}</v-alert>
    <v-dialog v-model="eidtUserDialog">
      <edit-user
        v-if="eidtUserDialog"
        @closeDialog="closeDialog"
        @createItem="createItem"
        @updateItem="updateItem"
        v-model="selectedItem"
        :action="action"
      />
      <v-alert style="white-space: pre;" :value="errorMessage.length>0">{{errorMessage}}</v-alert>
    </v-dialog>
    <v-data-table :headers="headers" :items="items" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.email }}</td>
          <td class="text-xs-left">{{ props.item.role }}</td>
          <td>
            <v-btn icon @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteItem(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import auth from "@/components/fireAuthInit";
import EditUser from "@/components/users/editUser.vue";
import firebase from "firebase";
import { crudErrorCodeToMessage } from "@/utils/errorMessages.js";
import {
  unixtimeToFormattedDate,
  unixtimeToJapaneseFormattedDate,
  differenceInYearsBetweenTodayAnd,
  validDateToUnixtime
} from "@/utils/datetime.js";
import { mapMutations } from "vuex";
import { authErrorCodeToMessage } from "@/utils/errorMessages.js";
import XLSX from "xlsx";
const chance = require("chance");

export default {
  components: {
    EditUser
  },
  data() {
    return {
      items: [],
      action: "add",
      eidtUserDialog: false,
      file: null,
      selectedItem: {},
      newItem: {
        id: "",
        name: "",
        email: "",
        first_password: "",
        birth: 0,
        sex: "",
        status: "creating"
      },
      errorMessage: "",
      errorMessages: [],
      headers: [
        {
          text: "名前",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Eメール",
          align: "left",
          sortable: false,
          value: "email"
        },
        {
          text: "ユーザー種別",
          align: "left",
          sortable: false,
          value: "role"
        },
 

        { text: "操作", sortable: false }
      ]
    };
  },
  mounted() {
    this.changeLoadingState(true);
    this.reloadItems();
  },
  methods: {
    async reloadItems() {
      this.items = [];
      const items = await db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("users")
        .get();
      items.forEach(doc => {
        this.items.push({ ...doc.data(), id: doc.id });
      });
      this.changeLoadingState(false);
    },
    getFormatDate(ut) {
      return unixtimeToFormattedDate(ut);
    },
    closeDialog() {
      this.errorMessage = "";
      this.eidtUserDialog = false;
    },
    async createItem() {
      const duplicate = this.ensureDuplicateUser(this.selectedItem);
      if (duplicate == "no-duplicate") {
        try {
          await db
            .collection("companies")
            .doc(this.$route.params.company_id)
            .collection("users")
            .add(this.selectedItem);
          this.errorMessage = "";
          this.closeDialog();
          this.reloadItems();
        } catch (e) {
          this.errorMessage = authErrorCodeToMessage(e.code);
        }
      } else {
        if (duplicate == "duplicate-user") {
          this.errorMessage = `ユーザーは登録済みです。`;
        } else if (duplicate == "duplicate-email") {
          this.errorMessage = `同じEメールアドレスで、異なる生年月日のユーザーが登録されています。\n同じメールアドレスで２人のユーザーを登録することはできません。\nユーザーを削除してから再度登録してください。`;
        }
      }
    },
    editItem(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.action = "update";
      this.eidtUserDialog = true;
    },
    addItem() {
      this.selectedItem = JSON.parse(JSON.stringify(this.newItem));
      this.action = "add";
      this.eidtUserDialog = true;
    },
    async deleteItem(item) {
      try {
        await db
          .collection("companies")
          .doc(this.$route.params.company_id)
          .collection("users")
          .doc(item.id)
          .delete();
        this.reloadItems();
      } catch (e) {
        console.log(e);
      }
    },
    async updateItem() {
      await db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("users")
        .doc(this.selectedItem.id)
        .set(this.selectedItem);
      this.closeDialog();
      this.reloadItems();
    },
    diffYearsFromToday(unixtime) {
      return unixtime ? differenceInYearsBetweenTodayAnd(unixtime) : "";
    },
    toJapaneseFormattedDate(unixtime) {
      return Number.isInteger(unixtime)
        ? unixtimeToJapaneseFormattedDate(unixtime)
        : "";
    },
    selectedFile(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },
    ensureDuplicateUser(user) {
      const duplicateUser = this.items.find(u => {
        return user.email == u.email;
      });
      if (duplicateUser) {
        if (duplicateUser.birth == user.birth) {
          return "duplicate-user";
        } else {
          return "duplicate-email";
        }
      } else {
        return "no-duplicate";
      }
    },
    ...mapMutations("app", ["changeLoadingState"])
  },
  created: function() {},
  watch: {}
};
</script>
<style lang="scss" scoped>
</style>